/**
 * Apply a chosen email signature to a draft body, idempotently.
 *
 * The signature is wrapped in a marker block so switching signatures REPLACES
 * the previous one rather than stacking. Passing an empty `signatureHtml`
 * strips any applied signature.
 */
const MARKER = 'data-maildesk-signature'
// Strip a previously-applied signature block (non-greedy, tolerant of attrs).
const SIG_BLOCK = new RegExp(
  `(<br\\s*/?>\\s*){0,2}<div[^>]*${MARKER}[^>]*>[\\s\\S]*?</div>\\s*$`,
  'i',
)

export function applySignatureToBody(bodyHtml: string, signatureHtml: string): string {
  const base = (bodyHtml || '').replace(SIG_BLOCK, '').trimEnd()
  if (!signatureHtml) return base
  return `${base}<br><br><div ${MARKER}="1">${signatureHtml}</div>`
}
